var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgClearIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.507878 0.213439C0.644564 0.0767742 0.829926 0 1.0232 0C1.21647 0 1.40184 0.0767742 1.53852 0.213439L4.99927 3.67469L8.46148 0.213439C8.59816 0.0767742 8.78353 0 8.9768 0C9.17008 0 9.35544 0.0767742 9.49212 0.213439L9.78659 0.507952C9.92324 0.644658 10 0.830047 10 1.02335C10 1.21665 9.92324 1.40204 9.78659 1.53875L6.32293 5L9.78513 8.46125C9.92178 8.59796 9.99854 8.78335 9.99854 8.97665C9.99854 9.16995 9.92178 9.35534 9.78513 9.49205L9.49066 9.78656C9.35398 9.92323 9.16862 10 8.97534 10C8.78207 10 8.59671 9.92323 8.46002 9.78656L4.99781 6.32531L1.53852 9.78656C1.40184 9.92323 1.21647 10 1.0232 10C0.829926 10 0.644564 9.92323 0.507878 9.78656L0.213408 9.49205C0.076763 9.35534 0 9.16995 0 8.97665C0 8.78335 0.076763 8.59796 0.213408 8.46125L3.67416 5L0.213408 1.53875C0.076763 1.40204 0 1.21665 0 1.02335C0 0.830047 0.076763 0.644658 0.213408 0.507952L0.507878 0.213439Z",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClearIcon);
export default __webpack_public_path__ + "static/media/clear_icon.8861aca4c83f5daa79f5d97da089fc7d.svg";
export { ForwardRef as ReactComponent };